import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    itemsWrapper: {},
    item: {
      fontSize: 16,
      lineHeight: '20px',
      color: colorsPalette.gray,
      cursor: 'default',
      [theme.breakpoints.up('sm')]: {
        fontSize: 16,
        lineHeight: '22px',
        '&:hover': {
          color: colorsPalette.violet,
        },
      },
    },
  }),
);
export default useStyles;
